import { api } from "./api";

const blobCache = new Map();
const thumbCache = new Map();
let pdfjsPromise = null;

export const fileUrl = (dossierId, f) =>
  f.kind === "email" ? `/dossiers/${dossierId}/attachment-by-index/${f.idx}?inline=1` : `/dossiers/${dossierId}/tab-data/${f.tab}/attachments/${f.id}`;

export const fileKey = (f) => (f.kind === "email" ? `email:${f.idx}` : `tab:${f.tab}:${f.id}`);

export function fileType(f) {
  const m = (f.mime_type || "").toLowerCase();
  const n = (f.filename || "").toLowerCase();
  if (m.startsWith("image/") || /\.(png|jpe?g|gif|webp|bmp|heic)$/.test(n)) return "image";
  if (m === "application/pdf" || n.endsWith(".pdf")) return "pdf";
  return "other";
}

export function loadPdfjs() {
  if (!pdfjsPromise) {
    pdfjsPromise = import("pdfjs-dist/build/pdf").then((lib) => {
      lib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;
      return lib;
    });
  }
  return pdfjsPromise;
}

export function getBlob(dossierId, f) {
  const k = `${dossierId}|${fileKey(f)}`;
  if (!blobCache.has(k)) {
    const p = api.get(fileUrl(dossierId, f), { responseType: "blob" }).then((r) => r.data);
    p.catch(() => blobCache.delete(k));
    blobCache.set(k, p);
  }
  return blobCache.get(k);
}

export async function openPdf(dossierId, f) {
  const [lib, blob] = await Promise.all([loadPdfjs(), getBlob(dossierId, f)]);
  return lib.getDocument({ data: await blob.arrayBuffer() }).promise;
}

export function getThumb(dossierId, f) {
  const k = `${dossierId}|${fileKey(f)}`;
  if (thumbCache.has(k)) return thumbCache.get(k);
  const t = fileType(f);
  const p = (async () => {
    if (t === "image") return URL.createObjectURL(await getBlob(dossierId, f));
    if (t !== "pdf") return null;
    const doc = await openPdf(dossierId, f);
    const page = await doc.getPage(1);
    const vp0 = page.getViewport({ scale: 1 });
    const vp = page.getViewport({ scale: 360 / vp0.width });
    const canvas = document.createElement("canvas");
    canvas.width = vp.width;
    canvas.height = vp.height;
    await page.render({ canvasContext: canvas.getContext("2d"), viewport: vp }).promise;
    return canvas.toDataURL("image/jpeg", 0.75);
  })();
  p.catch(() => thumbCache.delete(k));
  thumbCache.set(k, p);
  return p;
}

export async function downloadFile(dossierId, f) {
  const url = URL.createObjectURL(await getBlob(dossierId, f));
  const a = document.createElement("a");
  a.href = url;
  a.download = f.filename || "fichier";
  a.click();
}
